import './App.css';
import React, {useRef} from 'react';
import { useDispatch, useSelector } from "react-redux";
import CustomRouter from './routes/Router';
import {IdleTimer} from './IdleTimeOut';
import { initializePendo } from './redux/reducers/LoginSessionSlice';

function App() {
  IdleTimer();
  const dispatch = useDispatch();
  dispatch(initializePendo(true));
  return (
    <div className="App">
        <CustomRouter />
    </div>
  );
}

export default App;
